/** Formats a rating average rounded up to one decimal (e.g. 4.22 → "4.3"). */
export function formatRatingAverage(value: number | string): string {
    const rating = Number(value);

    if (!Number.isFinite(rating)) {
        throw new Error(`Invalid rating average: ${value}`);
    }

    return (Math.ceil((rating - Number.EPSILON) * 10) / 10).toFixed(1);
}
